import React from "react";
import { Spring } from "react-spring";

const VerticalProgress = ({ progress, vehicleData }) => {
  const formatMileage = (value) => {
    return Number(value).toFixed(2);
  };
  return (
    <Spring from={{ percent: 0 }} to={{ percent: progress }}>
      {() => {
        return (
          <div className={`d-flex justify-content-start gap-4 p-1`}>
            <div className="d-flex">
              <div className="progress vertical">
                <div
                  style={{ height: `${progress}%` }}
                  className="progress-bar"
                >
                  <span className="sr-only progress-percentage">{`${progress}%`}</span>
                </div>
              </div>
            </div>
            <div className="fuel-info">
              <div className="fuel-info-card">
                <p className="title">Total tank capacity</p>

                <p className="value">
                  {vehicleData.totalTankCapacity}{" "}
                  <span className="label">ltr</span>
                </p>
              </div>
              <div className="fuel-info-card">
                <p className="title">Current Fuel Level</p>
                <p className="value">
                  {vehicleData.currentFuel} <span className="label">ltr</span>
                </p>
              </div>
              <div className="fuel-info-card">
                <p className="title">Today Mileage</p>
                <p className="value mileage">
                  <span>
                    {formatMileage(vehicleData.mileage)}
                    <span className="label"> km/l</span>
                  </span>
                  <span className="mileageValue">
                    {vehicleData.mileageDistance} km / {vehicleData.mileageFuel}{" "}
                    l
                  </span>
                </p>
              </div>
              <div className="fuel-info-card">
                <p className="title">Avg. Mileage (30 days)</p>
                <p className="value">
                  {formatMileage(vehicleData.avgMileage)}
                  <span className="label"> km/l</span>
                </p>
              </div>
              <div className="fuel-info-card">
                <p className="title">Total Distance</p>
                <p className="value">
                  {vehicleData.distance} <span className="label">km</span>
                </p>
              </div>
            </div>
          </div>
        );
      }}
    </Spring>
  );
};

export default VerticalProgress;
